import { MainLayout } from "modules/layout/containers";
import PropTypes from "prop-types";
import React, { Component, Suspense, lazy, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Dialpad from "./dialpad/routes";
import CommonManager from "./helpers/common";
import AuthRoutes from "./modules/auth/routes";
import ErrorRoutes from "./modules/error/routes";
import AdminDashboardRoutes from "./modules/screens/AdminDashboard/routes";
import AgentDashboardRoutes from "./modules/screens/agentdashboard/routes";
import CompaignRoutes from "./modules/screens/campaign/routes";
import ChatScreen from "./modules/screens/chatscreen/routes";
import DialpadRoutes from "./modules/screens/dialpadDesign/routes";
import FlowRoutes from "./modules/screens/flow/routes";
import HomeRoutes from "./modules/screens/home/routes";
import InboundcallRoutes from "./modules/screens/inboundcall/routes";
import InsightsRoutes from "./modules/screens/insights/routes";
import LiveMonitorRoutes from "./modules/screens/livemonitor/routes";
import DynamicDashboardRoutes from "./modules/screens/dynamicDashboard/routes";
import ChartDashboardRoutes from "./modules/screens/chartDashboard/routes";
import MenuBarRoutes from "./modules/screens/menubar/routes";
import MessageRoute from "./modules/screens/message/routes";
import OrganizationRoutes from "./modules/screens/organization/routes";
import Region from "./modules/screens/Org_setting/Region/routes";
import OrganizationSettingRoutes from "./modules/screens/Org_setting/routes";
import BillingRoutes from "./modules/screens/reporting/Billing/routes";
import ReportingRoutes from "./modules/screens/reporting/routes";
import SettingsRoutes from "./modules/screens/settings/routes";
import TeamRoutes from "./modules/screens/team/routes";
import { Route, Redirect, Switch, useHistory } from "react-router-dom";
import PrivateRoutes from "./PrivateRoutes";
const PageNotFound = lazy(() =>
  import(
    /* webpackChunkName: "notfound" */ "./modules/error/components/PageNotFound"
  )
);

const commonmanager = new CommonManager();
export class MainRoutes extends Component {
  // renderRoutes() {
  //   return (
  //     <React.Fragment>
  //       {/* <Suspense fallback={"Loading"}> */}
  //         <ReportingRoutes />
  //         <Dialpad />
  //         <OrganizationRoutes />
  //         <OrganizationSettingRoutes />
  //         <Region/>
  //         <BillingRoutes />
  //         <MessageRoute />
  //         <InsightsRoutes />
  //         <TeamRoutes />
  //         <InboundcallRoutes />
  //         <CompaignRoutes />
  //         <FlowRoutes />
  //         {/* <FlowRoutesNew /> */}
  //         <SettingsRoutes />
  //         <DialpadRoutes />
  //         <AuthRoutes />
  //         <ErrorRoutes />
  //         <HomeRoutes />
  //         <AdminDashboardRoutes />
  //         <LiveMonitorRoutes />
  //         <AgentDashboardRoutes />
  //         <MenuBarRoutes />
  //         <ChatScreen />
  //         <Route render={() => <Redirect to="/not-found" />} />
  //       {/* </Suspense> */}
  //     </React.Fragment>
  //   );
  // }
  render() {
    const basename = process.env.BASE_PATH_PREFIX || "/";
    // update timezone
    commonmanager.getTimeZone();
    return (
      <Suspense fallback={"Loading"}>
      <Router basename={basename}>
        <Switch>
          <Route path="/">
            <MainLayout>
              {/* {this.renderRoutes()} */}

              <ReportingRoutes />
              <Dialpad />
              <OrganizationRoutes />
              <OrganizationSettingRoutes />
              <Region />
              <BillingRoutes />
              <MessageRoute />
              <InsightsRoutes />
              <TeamRoutes />
              <InboundcallRoutes />
              <CompaignRoutes />
              <FlowRoutes />
              {/* <FlowRoutesNew /> */}
              <SettingsRoutes />
              <DialpadRoutes />
              <AuthRoutes />
              {/* <Route
            // exact={true}
            path="/*"
            key="notadmin"
            component={() => {
              return (
                <NotFound />
              );
            }}
          /> */}
              <ErrorRoutes />
              <HomeRoutes />
              <AdminDashboardRoutes />
              <LiveMonitorRoutes />
              <DynamicDashboardRoutes />
              <ChartDashboardRoutes />
              <AgentDashboardRoutes />
              <MenuBarRoutes />
              <ChatScreen />
            </MainLayout>
          </Route>
          <Route path="*" component={PageNotFound} />
          {/* <Route component={() => <Redirect to="/not-found" />} /> */}
          {/* <Route key="notadmin" component={() => <NotFound />} /> */}
        </Switch>
      </Router>
      </Suspense>
    );
  }
}

function NotFound() {
  // const history = useHistory();
  useEffect(() => {
    console.log("why are you running");
    //   history.push("/not-found")
  });
  return <div>hemlooo</div>;
}

// TODO: try this:
{
  /* <Suspense fallback={"Loading"}>
  <Router basename={basename}>
    <Switch>
      <Route path="*" render={() => <Redirect to="/not-found" />} />
      <MainLayout>
        <ReportingRoutes />
        <Dialpad />
        <OrganizationRoutes />
      </MainLayout>
    </Switch>
  </Router>
</Suspense> */
}

MainRoutes.propTypes = {
  currentUser: PropTypes.object,
};

MainRoutes.contextTypes = {
  __: PropTypes.func,
};

export default MainRoutes;



// WEBPACK FOOTER //
// src/MainRoutes.js